<satinel-system-select
  [inputId]="id"
  [formlyField]="field"
  [formControl]="formControl"
  [options]="(items | async) || []"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [placeholder]="placeholder"
  [showClear]="showClear"
  [lazy]="lazy"
  [help]="help"
  [label]="label"
  [floatLabel]="floatLabel"
  [showFilter]="showFilter"
  [styleClass]="styleClass"
  [appendTo]="appendTo"
  [scrollHeight]="scrollHeight"
  [itemTemplate]="itemTemplate"
  [selectedItemTemplate]="selectedItemTemplate"
  [groupTpl]="groupTemplate"
  [readOnly]="readOnly"
  [required]="required"
  [configItems]="configItems"
  (lazyLoad)="lazyLoad($event)"
  (filter)="filter($event)"
  (sort)="sort($event)"
  [loading]="(loading | async) || false"
/>
